module.exports = __webpack_public_path__ + "static/media/Udemy1.bad1d7f5.JPG";